import styled, { css } from "styled-components";
import { DEFAULT_VERTICAL_RECTANGLE_WIDTH } from ".";

const verticalRectanglePositions = {
  1: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(1311px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(313px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  2: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(1219px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(520px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  3: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(1312px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(560px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  4: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(402px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(603px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  5: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(1140px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(654px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  6: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(289px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(151px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  7: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(1120px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(540px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  8: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(1260px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(589px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  9: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(1420px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(710px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  10: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(448px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(679px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
};

export const VerticalRectangleContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: ${({ size }) =>
    `calc(1080px / ${DEFAULT_VERTICAL_RECTANGLE_WIDTH / size})`};
  aspect-ratio: 9 / 16;

  ${({ size, label, shape }) => {
    return (
      size !== 1080 &&
      css`
        background-color: #f2f2f5;
        &::after {
          content: ${`"${label}"`};
          position: absolute;
          font-family: "Poppins";
          font-weight: 800;
          font-size: 12.65px;
          color: #3a3a3c;

          ${verticalRectanglePositions[shape]({ size })}
        }
      `
    );
  }}
`;

export const VerticalRectangleMask = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
`;

export const VerticalRectangleImage = styled.img`
  position: absolute;
  object-fit: cover;
  z-index: 10;
  ${({ top, left, size, x_axis }) => {
    return css`
      width: ${`${size.width}px`};
      height: ${`${size.height}px`};
      top: ${`${top}px`};
      left: ${`${left}px`};
      object-position: ${`${x_axis}% 50%`};
    `;
  }};
`;

export const DraggableVerticalRectangleContainer = styled.div`
  position: relative;
  overflow: hidden;
  ${({ size, background = "#fff" }) => {
    return css`
      width: ${`${size}px`};
      height: ${`${size / (9 / 16)}px`};
      background-color: ${background};
    `;
  }};
`;
